'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

exports.default = PanelContent;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

require('./panel.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * WH Panel Content Component.
 * @param {Object} props The new component properties.
 * @returns {React$Element<any>}  HTML markup for the component
 */
function PanelContent(props) {
    var _props$className = props.className,
        className = _props$className === undefined ? '' : _props$className,
        _props$id = props.id,
        id = _props$id === undefined ? '' : _props$id;


    var classNames = (0, _classnames2.default)((0, _defineProperty3.default)({
        'sb-panel-content': true
    }, '' + className, className));

    return (0, _jsx3.default)('div', {
        className: classNames,
        id: id
    }, void 0, props.children);
}
//# sourceMappingURL=PanelContent.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/ui-components/dist/main/components/panel/PanelContent.js
// module id = 590
// module chunks = 0